import { Injectable } from '@angular/core';
import { JwtAuthGuard, JwtAuthService } from '@devlearning/jwt-auth';
import { AuthenticationToken } from '../models/authentication-token';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { UserService } from '../services/user.service';
import { MENU_HOTAC, MENU_SUPPLIER_FOOD_SERVICE, MENU_SUPPLIER_TRANSPORT, MENU_TICKET } from '../utils/constants';
import { AuthRoleCodes } from '../models/auth-role-code';
import { AuthApplicationCodes } from '../models/auth-application-code';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends JwtAuthGuard<AuthenticationToken> {
  constructor(
    private readonly _router: Router,
    private readonly _jwtAuth: JwtAuthService<AuthenticationToken>,
    private readonly _user: UserService,
  ) {
    super(_jwtAuth);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivateBase(next, state).pipe(
      map((isLoggedIn) => {
        if (!isLoggedIn) {
          this._router.navigateByUrl('/login');
          return false;
        }

        const appSection = this._getAppSection(state);
        const authApplicationCode = this._user.userData?.authApplicationCode;
        const authRoleCode = this._user.userData?.authRoleCode;

        if (!authApplicationCode || !authRoleCode) {
          this._router.navigateByUrl('/login');
          return false;
        }

        if (appSection == null || appSection === '') {
          const index = this._getIndexPage(authApplicationCode, authRoleCode);

          if (index != null) {
            this._router.navigate([index]);
          }

          return true;
        }

        return true;
      }),
      catchError(() => {
        this._router.navigateByUrl('/login');
        return of(false);
      }),
    );
  }

  private _getAppSection(state: RouterStateSnapshot) {
    let appSection: string | null = state.url;

    if (appSection.startsWith('/')) {
      appSection = appSection.substring(1);
    }

    const slashIndex = appSection.indexOf('/');
    if (slashIndex >= 0) {
      appSection = appSection.substring(0, slashIndex);
    }

    return appSection;
  }

  private _getIndexPage(authApplication: string, authRole: string) {
    if (authApplication === AuthApplicationCodes.Repro) {
      switch (authRole) {
        case AuthRoleCodes.Admin:
        case AuthRoleCodes.CustomerAirlineCompanyAdmin:
        case AuthRoleCodes.CustomerAirlineCompanyUser:
          return MENU_TICKET;

        case AuthRoleCodes.SupplierTransportAdmin:
          return MENU_SUPPLIER_TRANSPORT;

        case AuthRoleCodes.SupplierFoodServiceAdmin:
        case AuthRoleCodes.SupplierFoodServiceUser:
          return MENU_SUPPLIER_FOOD_SERVICE;

        case AuthRoleCodes.SupplierHotelHotac:
          return MENU_HOTAC;

        case AuthRoleCodes.User:
        case AuthRoleCodes.Operator:
          return MENU_TICKET;

        default:
          return null;
      }
    }

    // if (authApplication === AuthApplicationCodes.App2) {
    //   switch (authRole) {
    //     case AuthRoleCodes.Admin:
    //       return '/sales/admin';

    //     case AuthRoleCodes.User:
    //       return '/sales';

    //     default:
    //       return null;
    //   }
    // }

    return null;
  }
}
